<template>
    <div class="modal hide fade in" id="modalVolumenes" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edición de Volumenes</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                            <div class="form-group col-4" id="Fojas_div"> 
                                <label>Fojas</label>                                  
                                <input type="text" class="form-control" v-model="Volumen.Fojas" />
                            </div>
                            <div class="form-group col-4" id="Contenedor_div"> 
                                <label>Contenedor</label>
                                <input type="text" class="form-control" v-model="Volumen.Contenedor" />
                            </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
                    <button type="button" class="btn btn-dark" id="botonAceptar" >Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
export default {
    data(){
        return{}
    },
    props: {
        Volumen: Object
    },
    methods:{
        Mostrar: function () {
            $('#modalVolumenes').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.ActualizarVolumen);
            },
        ModalClose: function(datos){
            $('#modalVolumenes').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {"Estatus" :false, "Actualizacion": datos});
        },
        ActualizarVolumen: function(){
            
            var peticion= { 
                "DocumentoId":this.Volumen.InventariodocumentoId,
                "Volumenes": this.Volumen
                    
            };
                console.log(peticion)   ;
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.GuardarVolumen, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then(respuesta => {
                      if (respuesta.data.SiHayError){
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("Se Modifico satisfactoriamente el Volumen");
                            comun.SeEstaCargandoInformacion(false);
                            this.ModalClose(true);
                        }
                        
                    })
                    .catch(e=> {
                        console.log("No Hay Respuesta del Servidor" + e);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                        });
        },
    },
    mounted(){
        this.Mostrar();
    }
}
</script>
<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }

input[type="text"]:read-only:focus {
      color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Movimientos/Recepcion/ModalEditVolumen.vue